<template>
  <el-skeleton :loading="loading" :rows="16" animated>

    <el-page class="trends-page" :bannerImageUrl="bannerImageUrl">
      <!-- 列表区域，使用Group布局 -->
      <div class="company-news">
        <pane-title class="pane" title="公司要闻" subTitle="NEWS & EVENTS" />
        <div class="trends-content">
          <div class="trends-item-wrapper" v-for="(item, index) in currentCompanyNewsList" :key="index">
            <div class="trends-item" @click="jumpDetail(item)">
              <div class="trends-item-image">
                <img v-if="!!item.pcImgUrl" :src="item.pcImgUrl" />
              </div>
              <div class="trends-item-text-wrapper">
                <span class="title">{{ item.title }}</span>
              </div>
            </div>
          </div>
          <div class="pagination-wrapper">
            <el-pagination hide-on-single-page background layout="prev, pager, next"
              :current-page="companyNewsCurrentPage" :page-size="companyNewsPageSize" :total="companyNewsList.length"
              @current-change="(page) => onCurrentCompanyNewsPageChange(page)">
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="industry-news">
        <pane-title class="pane" title="行业洞察" subTitle="INDUSTRY INSIGHT" />
        <div class="trends-content">
          <div class="trends-item-wrapper" v-for="(item, index) in currentIndustryNewsList" :key="index">
            <div class="trends-item" @click="jumpDetail(item)">
              <div class="trends-item-image">
                <img v-if="!!item.pcImgUrl" :src="item.pcImgUrl" />
              </div>
              <div class="trends-item-text-wrapper">
                <span class="title">{{ item.title }}</span>
              </div>
            </div>
          </div>
          <div class="pagination-wrapper">
            <el-pagination hide-on-single-page background layout="prev, pager, next"
              :current-page="industryNewsCurrentPage" :page-size="industryNewsPageSize" :total="industryNewsList.length"
              @current-change="(page) => onIndustryNewsPageChange(page)">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-page>
  </el-skeleton>
</template>

<script>
import PaneTitle from '../../components/PaneTitle/PaneTitle.vue';
import moment from 'moment';
export default {
  name: "trends",
  components: { PaneTitle },
  data() {
    return {
      loading: true,
      bannerImageUrl: null,
      companyNewsPageSize: 10,
      companyNewsCurrentPage: 1,
      industryNewsPageSize: 10,
      industryNewsCurrentPage: 1,
      companyNewsList: [],
      industryNewsList: []
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    newsPageNo() {
      return Math.ceil(this.companyNewsList.length / this.companyNewsPageSize);
    },
    currentCompanyNewsList() {
      const start = (this.companyNewsCurrentPage - 1) * this.companyNewsPageSize;
      const end = start + this.companyNewsPageSize;
      return this.companyNewsList.slice(start, end)
    },
    currentIndustryNewsList() {
      const start = (this.industryNewsCurrentPage - 1) * this.industryNewsPageSize;
      const end = start + this.industryNewsPageSize;
      return this.industryNewsList.slice(start, end)
    }
  },
  methods: {
    formatPublishTime(timestamp) {
      // 假设 timestamp 是 YYYYMMDD 格式的字符串
      if (!timestamp) return '';

      // 设置语言
      moment.locale(this.lang === 'zh' ? 'zh-cn' : 'en');

      // 将 YYYYMMDD 转换为日期对象
      const date = moment(timestamp.toString(), 'YYYYMMDD');

      // 根据语言返回不同格式
      if (this.lang === 'zh') {
        return date.format('YYYY.MM.DD');
      } else {
        return date.format('MMM DD, YYYY');
      }
    },
    onCurrentCompanyNewsPageChange(page) {
      this.companyNewsCurrentPage = page;
    },
    onIndustryNewsPageChange(page) {
      this.industryNewsCurrentPage = page;
    },
    jumpDetail(item) {
      const link = item.jumpUrl;
      if (link === 'local') {
        window.open('/news-detail/' + item.id);
      } else if (link) {
        window.open(link)
      }
    },
    configData(record) {
      this.companyNewsList = (record['51'] && record['51'] || []).sort((prev, next) => {
        return next.publishTime - prev.publishTime;
      });
      this.industryNewsList = (record['52'] && record['52'] || []).sort((prev, next) => {
        return next.publishTime - prev.publishTime;
      });
    },
    getData(language) {
      this.$http.getOnlyContent({
        itemType: '5',
        platform: 'pc',
        language
      }).then(res => {
        this.configData(res.crmOweContentMaps || {});
        this.bannerImageUrl = res.imageMaps && res.imageMaps['50'] && res.imageMaps['50'][0] && res.imageMaps['50'][0].imgUrl;
        this.loading = false;
      });
    },
    getDataByLang(lang) {
      if (lang === 'zh') {
        this.getData('china');
      } else {
        this.getData('english');
      }
    }
  },

  watch: {
    "$i18n.locale": {
      immediate: true,
      handler(v) {
        this.getDataByLang(v);
      }
    },
  }
}
</script>

<style scoped lang="less">
.trends-page {
  .company-news,
  .industry-news {
    margin: 3rem 0;
    padding:0 15rem;
  }

  .trends-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 2rem;
    .trends-item-wrapper {
      position: relative;
      box-shadow: 0px 5px 8px 4px rgba(3, 118, 152, 0.06);
      flex: 0 0 calc(50% - 2.5rem);
      /* 每个元素占 1/3 */
      margin: 1.25rem;

      .right-bottom-tag {
        position: absolute;
        display: inline;
        background-color: #EEEEEE;
        padding: 0.25rem 2rem;
        right: 0;
        bottom: 1.5rem;
        color: #CCCCCC;
      }
    }

    .trends-item {
      cursor: pointer;
      &-image {
        background-color: var(--placehoder-color);
        width: 100%;
        aspect-ratio: 713 / 352;

        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      &-text-wrapper {
        position: absolute;
        bottom: 0;
        height: 4rem;
        width: 100%;
        background: rgba(0, 0, 0, 0.50);
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        .title {
          font-weight: bold;
          font-size: 1.25rem;
          color: white;
          white-space:nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          bottom: 0;
          margin: 1rem;
        }
      }
    }

  }

  .pagination-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}


/* 小屏幕（移动端） */
@media screen and (max-width: 767px) {
  .trends-page {
    .company-news,
    .industry-news {
      margin: 3rem 0;
      padding:0;
    }
  
    .trends-content {
      .trends-item-wrapper {
        flex: 0 0 100%;
        /* 每个元素占 1/3 */
        margin: 1rem 0;
  
      }
  
      .trends-item {
        &-text-wrapper {
          .title {
          }
        }
      }
  
    }
  
    .pagination-wrapper {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
@media screen and (max-width: 767px) { 
  .trends-page .trends-content .trends-item-text-wrapper .title{
            font-size: 1.3333rem;
  }

}
</style>